var map = {
	"./result_1.png": "OpM7",
	"./result_2.png": "qZPM",
	"./result_3.png": "cd1b",
	"./result_4.png": "EzQe",
	"./result_5.png": "w2Hd",
	"./result_6.png": "ijA1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dh1n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ngs_second/transcriptome/sequencing ^\.\/result_.*\.png$
// module id = dh1n
// module chunks = 16